// Preview injection script
// This file can be used for preview-specific functionality
console.log('Preview mode initialized')
